import React, { useState, useEffect} from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import "../assets/css/styles.table.css"
import Layout from './Layout';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {Modal, Typography} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ConfirmationButton from '../components/ConfirmationButton.js';
import UploadFile from '../components/Upload.js';
import VirtualizedSelect from 'react-virtualized-select';
import {useInvoicesListHook} from '../hook/InvoicesListHook.js'
import DynamicDataGridComponent from '../components/DynamicDataGrid'
import GridNumberPaging from '../components/GridNumberPaging.js'
import { DynamicSelect } from '../components/DynamicSelect';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import DialogForm from '../components/Dialog.js'
import Payment from '../components/Payment.js'
import Bindcomponent from '../utils/bindcomponent.js';
const InvoiceListV3 = () => {
    const { id } = useParams();
    const Navigate = useNavigate();
    const {message,setmessage,errorType,setErrorType,handleSelectedProject,selectedOptionProject,setOpenSplit,roleAccess,GetRetention,setRetensi,setPeriodNumber,setPeriod,setOpenRetention,openRetention,handleRetentionClose,handleSaveRetention,isNullRetention,retensi,periodNumber,period,openSplit,handleSplitClose,handleSaveSplitInv,invSplitId,rowsSplit,rowNumber,splitInvTotal,setsplitInvTotal,columnsSplit,columns,rows,print,setPrint,content,openPopupAndPrintPo,result,productopen,handleUploadDialogClose,invoiceId} = useInvoicesListHook(id)
  
  return (
    <>
       
    <Layout message={message} setmessage={setmessage} tipe={errorType} settipe={setErrorType}>
  <div className='pd' style={{backgroundColor:'gray', color:'white',marginLeft:15,marginRight:15}}><b>INVOICE LIST</b> 
  
  </div>
 
  <div className="pd">
 
  <Box sx={{backgroundColor:"gray", padding:2, marginBottom:2, boxShadow:3}}>
     <Bindcomponent component='DynamicSelect'  label={`{name} --- {subject} | {quotation_id} | {po_no} | TOTAL PROJECT : {totalpo}`} value={"id"} selectedvalue={selectedOptionProject}  onChange={(option) => {
                            handleSelectedProject(option)
                            }}
                            url={"GetAllListPO"} id="projectSelect" disabled={false} required={false} appendTopOption={[{label :'ALL INVOICES', value :"00000000000000"}]}></Bindcomponent>  
 
        {/* <VirtualizedSelect
                                        options={projectList}
                                        onChange={(option) =>  handleSelectedProject(option)}
                                        value={selectedOptionProject}
                                        clearable={false}
                                        searchable={true}
                                        required
                                       
                                    />  */}
        
    </Box>
  <Box sx={{ p: 2,m:0,boxShadow:3, border: '1px solid grey',backgroundColor :"#f6f6f6", marginBottom:3,fontSize:12}}>
      Note : Invoice use the latest data from the PO, changes to PO data after the invoice is issued do not change the invoice, except for the addition of PO. So make sure the data is fixed before filling in the invoice
    </Box>
    <Box style={{position:'relative', backgroundColor:'#f3f3f3' }} sx={{boxShadow:3 }}>
        {id !=="00000000000000" && (
    //    <div style={{marginBottom:15}}><button className='btn btn-success' onClick={AddProjectData} disabled={!roleAccess.CREATE}>Add Invoice</button></div>
       <div style={{marginBottom:15}}><button className='btn btn-primary' onClick={()=> setOpenSplit(true)} disabled={!roleAccess.CREATE} sx={{boxShadow:3}} style={{margin:3}}>+ Split Invoice</button></div>
    )}
       <div style={{position:'absolute', right:0,top:0}}>
        {id !=="00000000000000" && (
       <button style={{margin:3}} className='btn btn-primary' disabled={!roleAccess.CREATE} onClick={async () => {
           // const response = await AxiosFetchData.get(`GetRetention/${id}`).refreshToken(Navigate);
            const response = await GetRetention();
           // console.log(response)
            if(response.data){
              setRetensi(response.data.retensi)
              setPeriodNumber(response.data.period_number)
              setPeriod(response.data.period)
            }
            setOpenRetention(true)
        }}>+ Retention</button>
      )}
       <Dialog
        open={openRetention}
        onClose={handleRetentionClose}
        height={450}
         
      >
        
        <form id="formRetention" onSubmit={handleSaveRetention} >
        <DialogContent>
          <DialogContentText>
          <h4>RETENTION</h4><br></br>
          {isNullRetention && (
             <span style={{fontSize:12}}>You must fill in the retention before continue</span>
          )}
         
            <hr></hr>
          </DialogContentText>
         
           <FormControl sx={{ m: 1}} size="small" > 
          
              <div className='form-group row'>
                <label class="col-sm-4">Retention</label>
                <div class="col-sm-4">
                  <input
                              type="number"
                              className="form-control"
                              placeholder="Retention"
                              value={retensi}
                              onChange={(e) => setRetensi(e.target.value) }
                              name="txtRtn"
                              min={0}
                              required
                             
                             // onChange={(e) => handleText(e.target.value, index)}
                            />
              </div>
              <label >%</label>
            </div>
            <div className='form-group row'>
              <label  class="col-sm-4">Time Period</label>
              <div class="col-sm-4">
<               input
                              type="number"
                              className="form-control"
                              placeholder="Retention"
                              value={periodNumber}
                              onChange={(e) => setPeriodNumber(e.target.value) }
                              name="txtPeriod"
                              min={0}
                              required
                />
              </div>
              <div class="col-sm-4">
           
              <Select
                value={period}
                onChange={(event)=> setPeriod(event.target.value)}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                required
                name="optPeriod"
              >
                 <MenuItem value="">
            <em>None</em>
              </MenuItem>
                <MenuItem value={"YEAR"}>Year</MenuItem>
                <MenuItem value={"MONTH"}>Month</MenuItem>
                <MenuItem value={"WEEK"}>Week</MenuItem>
                <MenuItem value={"DAY"}>Day</MenuItem>
              </Select>
            
          </div>  
          </div>    
          
           </FormControl>       
           <hr></hr>
        </DialogContent>
        <DialogActions>
          <button className='btn btn-danger' onClick={() => handleRetentionClose()} type="button"   >CANCEL</button>
          {/* <button className='btn btn-primary' type="submit">SAVE1</button>   */}
          <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit"  title="Save" disabled={!roleAccess.CREATE} formid="formRetention" id="btnSubmit" >
               SAVE    
          </ConfirmationButton>
        </DialogActions>
        </form>    
      </Dialog>

      <Dialog
        open={openSplit}
        onClose={handleSplitClose}
        height={450}
         
      >
        
        <form id="formSplit" onSubmit={handleSaveSplitInv} >
        <DialogContent>
          <DialogContentText>
          <h4>SPLIT INVOICE #{invSplitId ? rowNumber : (rowsSplit.length + 1)}</h4><hr/>
         
          </DialogContentText>
         
           <FormControl sx={{ m: 1}} size="small" > 
          
              {/* <div className='form-group row'>
                <label class="col-sm-3">Name</label>
                <div class="col-sm-7">
                  <input
                        type="text"
                        className="form-control"
                        placeholder="Name"
                        value={name}
                        onChange={(e) => setName(e.target.value) }
                        name="txtNameInv"
                        required
                      
                             
                  />
              </div>
           
            </div> */}
            <div className='form-group row'>
              <div  class="col-sm-5">Total Split Value</div>
              <div class="col-sm-7">
<               input
                              type="number"
                              className="form-control"
                              placeholder="Total"
                              value={splitInvTotal}
                              onChange={(e) => setsplitInvTotal(e.target.value) }
                              name="txtTotalInv"
                              min={1}
                              required
                             
                         
                            />
              </div>
              
          </div>    
          
           </FormControl>       
           <hr></hr>
        </DialogContent>
        <DialogActions>
          <button className='btn btn-danger' onClick={async () => await handleSplitClose()} type="button"   >CANCEL</button>
          {/* <button className='btn btn-primary' type="submit">SAVE1</button>   */}
          <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit"  title="Save" disabled={!roleAccess.CREATE} formid="formSplit" id="btnSubmit" >
               SAVE    
           </ConfirmationButton>
        </DialogActions>
        </form>    
      </Dialog>
       </div>
    </Box>
   
  {rowsSplit.length > 0 && (
  <Box sx={{ boxShadow:3 }} >
     <Bindcomponent component='GridNumberPaging'  customcolumns={columnsSplit} rows={rowsSplit} name={"splitgrid"} rowid={"id"}></Bindcomponent>  
        {/* <GridNumberPaging customcolumns={columnsSplit} rows={rowsSplit} name={"splitgrid"} rowid={"id"}></GridNumberPaging> */}
        {/* <DataGrid className='fonty'
          columns={columnsSplit}
          sx={{backgroundColor:'#f3f3f3'}}
          rows={rowsSplit}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
        /> */}
      </Box>
      )}

 
      <Box sx={{ marginTop:5, boxShadow:3 }} >
     
        <div style={{padding:2, backgroundColor:'#f3f3f3'}}>
            <h4>Invoice List</h4> 
        </div>
         <Bindcomponent component='GridNumberPaging'  customcolumns={columns} rows={rows} name={"invoicesgrid"} rowid={"id"}></Bindcomponent>  
        {/* <GridNumberPaging customcolumns={columns} rows={rows} name={"invoicesgrid"} rowid={"id"}></GridNumberPaging> */}
        {/* <DataGrid className='fonty'
          columns={columns}
          rows={rows}
          sx={{backgroundColor:'#f3f3f3'}}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          slots={{ toolbar: GridToolbar }}
          filterModel={filterModel}
          onFilterModelChange={(newModel) => setFilterModel(newModel)}
          slotProps={{ toolbar: { showQuickFilter: true } }}
          columnVisibilityModel={columnVisibilityModel}
          onColumnVisibilityModelChange={(newModel) =>
            setColumnVisibilityModel(newModel)
          }
        /> */}
      </Box>
     
    </div>
 
  <Modal
        open={print}
        onClose={() => setPrint(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        id="satu"
      >
        <Box className='modals' >
        <div id="testId" className="test"> 
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <div id="modalcontent" dangerouslySetInnerHTML={content}>
              
            </div>
           
          </Typography>
          <Typography id="modal-modal-description">
          <button
              onClick={() => openPopupAndPrintPo(result)}
              className='close-button'
            >
              Print
            </button>
            &nbsp;
            <button
              onClick={() => setPrint(false)}
              className='close-button'
            >
              Close
            </button>
          </Typography>
          </div>
        </Box>
        </Modal>
 
        <UploadFile productopen={productopen} handleClose={handleUploadDialogClose}  id={invoiceId} navigate={Navigate} table="invoice" type="invoice"></UploadFile>
        </Layout>
        {/* <DialogForm title={"Payment"} open={paymentOpen} setOpen={setPaymentOpen} maxWidth='sm'>
          <Payment></Payment>
        </DialogForm> */}
    </>
  );
};

export default InvoiceListV3;